import { render, staticRenderFns } from "./changePw.vue?vue&type=template&id=379c465e&scoped=true&"
import script from "./changePw.vue?vue&type=script&lang=js&"
export * from "./changePw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379c465e",
  null
  
)

export default component.exports